import * as Sentry from '@sentry/react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button, Card } from './ui'

export default function PageErrorBoundary({ children }: { children: React.ReactNode }) {
  const location = useLocation()
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <Sentry.ErrorBoundary
      key={location.pathname}
      fallback={({ error, resetError }) => (
        <div className="p-4 sm:p-8 mx-auto w-full max-w-2xl">
          <Card tone="danger" className="p-6">
            <h2 className="text-lg font-semibold text-red-700 mb-2">
              {t('errors.pageTitle')}
            </h2>
            <p className="text-sm text-gray-600 mb-4">
              {t('errors.pageBody')}
            </p>
            {import.meta.env.DEV && error instanceof Error && (
              <pre className="text-xs bg-gray-50 border border-gray-200 rounded p-3 overflow-auto max-h-48 mb-4 text-gray-700">
                {error.message}
              </pre>
            )}
            <div className="flex gap-2">
              <Button size="sm" onClick={resetError}>
                {t('errors.tryAgain')}
              </Button>
              <Button size="sm" variant="secondary" onClick={() => { resetError(); navigate(-1) }}>
                {t('errors.goBack')}
              </Button>
              <Button size="sm" variant="secondary" onClick={() => { resetError(); navigate('/dashboard') }}>
                {t('errors.goDashboard')}
              </Button>
            </div>
          </Card>
        </div>
      )}
    >
      {children}
    </Sentry.ErrorBoundary>
  )
}
